import { useFormik } from "formik";
import { useAppDataStore } from "@/mobx/appDataStore.jsx";
import { useState } from "react";

export default function ForcedPasswordChange({ onSuccess }) {
  const appDataStore = useAppDataStore();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [successMessage, setSuccessMessage] = useState('');

  const formik = useFormik({
    initialValues: {
      oldPassword: '',
      newPassword1: '',
      newPassword2: ''
    },
    onSubmit: async (values) => {
      setError('');
      setSuccessMessage('');

      // Validaciones
      if (!values.oldPassword) {
        setError('La contraseña actual es requerida');
        return;
      }

      if (!values.newPassword1) {
        setError('La nueva contraseña es requerida');
        return;
      }

      if (values.newPassword1.length < 6) {
        setError('La nueva contraseña debe tener al menos 6 caracteres');
        return;
      }

      if (values.newPassword1 !== values.newPassword2) {
        setError('Las contraseñas no coinciden');
        return;
      }

      try {
        setLoading(true);
        const res = await appDataStore.post('/auth/changePassword', {
          oldPassword: values.oldPassword,
          newPassword1: values.newPassword1,
          newPassword2: values.newPassword2,
        });

        // Actualizar el estado del usuario para marcar que ha cambiado la contraseña
        if (appDataStore.user) {
          appDataStore.user.passwordChanged = true;
        }

        setSuccessMessage('¡Contraseña actualizada exitosamente!');
        setTimeout(() => {
          onSuccess();
        }, 1500);
      } catch (err) {
        setError(err.message || 'Error al cambiar la contraseña');
      } finally {
        setLoading(false);
      }
    }
  });

  return (
    <>
      <div className="flex min-h-full flex-1 flex-col justify-center px-6 py-12 lg:px-8">
        <div className="sm:mx-auto sm:w-full sm:max-w-sm">
          <h2 className="mt-10 text-center text-2xl font-bold leading-9 tracking-tight text-gray-900">
            Cambio de contraseña requerido
          </h2>
          <p className="mt-2 text-center text-sm text-gray-600">
            Su contraseña ha sido restablecida por un administrador. Por favor, establezca una nueva contraseña para continuar.
          </p>
        </div>

        <div className="mt-10 sm:mx-auto sm:w-full sm:max-w-sm">
          <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-6">
            <p className="text-sm text-blue-800">
              ⚠️ Este cambio es obligatorio para acceder a su cuenta.
            </p>
          </div>

          <form className="space-y-4">
            <div>
              <label htmlFor="oldPassword" className="block text-sm font-medium leading-6 text-gray-900">
                Contraseña actual
              </label>
              <div className="mt-2">
                <input
                  id="oldPassword"
                  name="oldPassword"
                  type="password"
                  value={formik.values.oldPassword}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  disabled={loading}
                  className="block w-full rounded-md border-0 py-1.5 px-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6 disabled:bg-gray-100"
                />
              </div>
            </div>

            <div>
              <label htmlFor="newPassword1" className="block text-sm font-medium leading-6 text-gray-900">
                Nueva contraseña
              </label>
              <div className="mt-2">
                <input
                  id="newPassword1"
                  name="newPassword1"
                  type="password"
                  value={formik.values.newPassword1}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  disabled={loading}
                  className="block w-full rounded-md border-0 py-1.5 px-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6 disabled:bg-gray-100"
                />
              </div>
              <p className="text-xs text-gray-500 mt-1">Mínimo 6 caracteres</p>
            </div>

            <div>
              <label htmlFor="newPassword2" className="block text-sm font-medium leading-6 text-gray-900">
                Confirmar contraseña
              </label>
              <div className="mt-2">
                <input
                  id="newPassword2"
                  name="newPassword2"
                  type="password"
                  value={formik.values.newPassword2}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  disabled={loading}
                  className="block w-full rounded-md border-0 py-1.5 px-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6 disabled:bg-gray-100"
                />
              </div>
            </div>

            {error && (
              <div className="text-red-600 text-sm bg-red-50 border border-red-200 rounded p-3">
                {error}
              </div>
            )}

            {successMessage && (
              <div className="text-green-600 text-sm bg-green-50 border border-green-200 rounded p-3">
                {successMessage}
              </div>
            )}

            <div>
              <button
                type="button"
                onClick={formik.submitForm}
                disabled={loading}
                className="flex w-full justify-center rounded-md bg-blue-600 hover:bg-blue-700 disabled:bg-gray-400 px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600"
              >
                {loading ? 'Actualizando...' : 'Actualizar contraseña'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}
